module.exports = __webpack_public_path__ + "static/media/news6.4aa756a2.png";